<ng-template appActionHost></ng-template>
<p *ngIf="!action?.actionComponent">no action component found!</p>

